export default {
  "value": {
    "sections": [],
    "categories": []
  }
};
